(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    const updateProductMediaImageState = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.classList.contains('product-media__image')) return;

    const media = image.closest('.product-media');
    if (!media || media.querySelector('.product-media__kurlective-fallback') === null) return;

    if (image.complete && image.naturalWidth === 0) {
      media.dataset.imageState = 'error';
    } else if (image.naturalWidth > 0) {
      delete media.dataset.imageState;
    }
  };

  document.addEventListener(
    'error',
    (event) => {
      updateProductMediaImageState(event.target);
    },
    true
  );

  document.addEventListener(
    'load',
    (event) => {
      updateProductMediaImageState(event.target);
    },
    true
  );

  document.querySelectorAll('.product-media__image').forEach(updateProductMediaImageState);
  } catch(e) { console.error(e); }
})();

})();
